<script lang="ts">
	import { Datepicker, SearchInput } from '$lib/components';
	import { searchDate } from '$lib/stores/search.svelte';

	type Props = {
		minDate?: Date;
		error?: string | string[];
		reset?: boolean;
	};

	let { minDate, error = undefined, reset = false }: Props = $props();

	const setDate = (e: string) => {
		searchDate.current = e;
		error = undefined;
	};
</script>

<SearchInput {error}>
	<label for="pickup-date" class="input-label">Pickup Date</label>
	<Datepicker
		id="pickup-date"
		name="date"
		{minDate}
		{setDate}
		value={searchDate.current}
		placeholder="Select a date"
		focus={!!error}
		{reset}
	/>
</SearchInput>
